










































import { ResultSortScoreCriteria } from '@empathybroker/tsclient-search';

import { ColorEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import { SteppedAnimationMixin } from '../../mixins';

import { ExplainScoreCriteriaMessages } from '../../models';

import { ArrayUtils, ExplainUtils } from '../../utils';

import Badge from '../badge.component.vue';

export default {
  name: 'explain-result-score-stepper',
  props: {
    result: {
      type: Object,
      required: true
    },
    initialAnimationDurationInMillis: {
      type: Number,
      default: 0
    },
    defaultCriteriaDetailTypes: {
      type: Array,
      default: () => []
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge
  },
  mixins: [SteppedAnimationMixin],
  computed: {
    scoreCriteria: function (): ResultSortScoreCriteria {
      return ExplainUtils.getResultScoreCriteria(this.result);
    },
    totalValueText: function (): string {
      return Number(this.scoreCriteria.value).toLocaleString(this.$epb.locale);
    },
    criteriaDetailTypes: function (): (ScoreCriteriaDetailTypeEnum | string)[] {
      return ArrayUtils.union(this.defaultCriteriaDetailTypes, Object.keys(this.scoreCriteria.details));
    }
  },
  data: function () {
    return {
      animationStepDurationsInMillis: [this.initialAnimationDurationInMillis],
      playAnimationOnce: true,
      ColorEnum
    };
  },
  methods: {
    getCriteriaDetailMessages(criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(criteriaDetailType, this.messages);
    },
    getCriteriaDetailTransitionDelay(detailIndex: number): string {
      if (!!this.initialAnimationDurationInMillis && !this.alreadyPlayedAnimation) {
        const detailAnimationDurationInMillis = (this.initialAnimationDurationInMillis / (this.criteriaDetailTypes.length + 1));
        return `${ (detailAnimationDurationInMillis * detailIndex) }ms`;
      }
    },
    getCriteriaDetailIcon(criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      return ExplainUtils.getResultScoreCriteriaDetailIcon(criteriaDetailType);
    },
    getCriteriaDetailIconAlt(criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      return this.getCriteriaDetailMessages(criteriaDetailType).abbr.substring(0, 1);
    },
    getCriteriaDetailValueText: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      const scoreCriteriaDetail = this.scoreCriteria.details[criteriaDetailType];
      return !!scoreCriteriaDetail ? this.$epb.utils.formatNumber(scoreCriteriaDetail.value, { maximumFractionDigits: 2 }, true) : '-';
    }
  }
};
